import { Link, useLocation, useNavigate } from "react-router-dom";
import "./WebCheckInSuccess.css";
import { useEffect, useState } from "react";
import BookingNavbar from "../../Bookings/Navbar/BookingNavbar";

 
export default function CheckInSuccess() {

  const location = useLocation();
  const navigate = useNavigate();
  const [navbarActive, setNavbarActive] = useState('myBookings'); // Control navbar active state
  
  const guests = location.state?.guests || [];
  const hotelName = location.state?.hotelName || "";
  const hotelAddress = location.state?.hotelAddress || ""; 
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";
  const activeTab = location.state?.activeTab || "";
  const status = location.state?.status || "";
  const bookingId = location.state?.bookingId || "";
  const hotelId = location.state?.hotelId || "";




  useEffect(()=>{
      const checkData = ()=>{
        if(guests.length===0){
          navigate("/bookings")
        }
      }
      checkData();
  },[guests,navigate]);

  const handleBack = () => {
    navigate(`/bookings/${bookingId}`);
  }

  const handleClickBookings = () => {
    try{
      navigate("/bookings", {
        state : {
          bookingNavStatus :"myBookings",
        }
      })
    }catch(error){
      console.log(error);
    }
  }

  const handleClickRequests = () => {
    try{
      navigate("/bookings",{
        state : {
          activeRequests :"requests",
        }
      })

    }catch(error){
      console.log(error);
    }
  }

  // The shared footer reports which tab was tapped; this screen is not a tab, so
  // instead of switching an active state it leaves for the bookings page.
  const handleNavbarSelect = (selected) => {
    setNavbarActive(selected);
    if(selected === "requests"){
      handleClickRequests();
      return;
    }
    handleClickBookings();
  }

  return (
    <>
      <div className="checkin-page-success">
        <div onClick={()=>handleBack()} className="back-btn">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <span></span>
        </div>

        <div className="success-icon">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 12.5L9.5 17L19 7"
              stroke="#2FA56A"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2>You're all checked in!</h2>

        <p className="subtitle">
          Your details have been submitted. Alfred will send confirmation on
          WhatsApp shortly.
        </p>

        <div className="card">
          <div className="card-title">CHECKED-IN GUESTS</div>

          {guests.map((guest, index) => (
            <div
              key={guest.name}
              className={`guest-row ${
                index === guests.length - 1 ? "last" : ""
              }`}
            >
              <div className="avatar">
                  {guest.name?.charAt(0).toUpperCase() || ""}
              </div>

              <div className="guest-info">
                <div className="guest-name">{guest.name}</div>

                {guest.lead && (
                  <div className="guest-role">Lead guest</div>
                )}
              </div>

              <div className="verified-badge">
                ✓ ID verified
              </div>
            </div>
          ))}
        </div>

        <div className="next-card">
          <div className="card-title brown">
            WHAT HAPPENS NEXT
          </div>

          <div className="next-item">
            <span>✅</span>
            <p>Hotel team reviews your IDs</p>
          </div>

          <div className="next-item">
            <span>📱</span>
            <p>WhatsApp confirmation sent to you</p>
          </div>

          <div className="next-item">
            <span>🚀</span>
            <p>Alfred prepares your caretaker brief</p>
          </div>
        </div>
        
        <BookingNavbar navbarActive={navbarActive} setNavbarActive={handleNavbarSelect} />
 
      </div>
    </>
  );
}